var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('app-sidebar'),_vm._v(" "),_c('section',{staticClass:"content",staticStyle:{"overflow":"auto"}},[_c('article',{staticClass:"markdown-section"},[_c('router-view'),_vm._v(" "),_c('app-footer')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }